import RoutingActions from '../../../actions/RoutingActions';
import NotificationActions from '../../../actions/NotificationActions';
import PosActions from '../../../actions/PosActions';
import PosCartActions from '../../../actions/PosCartActions';
import PopupActions from '../../../actions/PopupActions';
import AjaxPromises from '../../../utils/AjaxPromises';
import PosStore from '../../../stores/PosStore';
import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';
import PermissionStore from '../../../stores/PermissionStore';

import { endPoints as EndPoints } from '../../../constants/PosCartConstants';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';
import { Permissions } from '../../../constants/PermissionConstants';

class AddDiscount extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            load        : false,
            type_of_discount : 'ONE',
            amount      : 0,
            percent     : 0,
            description : '',
            selected    : false,
            managerPin : '',
            ApprovingManagerUserId: null,
        };

        this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
        this.addDiscount = this.addDiscount.bind(this);
        this.onAmountChange = this.onAmountChange.bind(this);
        this.onPercentChange = this.onPercentChange.bind(this);
        this.onDescriptionChange = this.onDescriptionChange.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.selected = this.selected.bind(this);
        this.checkManagerPin = this.checkManagerPin.bind(this);
    }

    componentWillReceiveProps(next) {
        if (!next.selectedDiscount) {
            return;
        }

        var selected = '';
        if (next.selectedDiscount.FlatFee !== 0) {
            selected = 'amount';
        }

        if (next.selectedDiscount.PercentOff !== 0) {
            selected = 'percent';
        }

        this.setState({
            selected: selected,
            amount: next.selectedDiscount.FlatFee,
            percent: next.selectedDiscount.PercentOff * 100,
            description: next.selectedDiscount.ProductDesc,
            type_of_discount: next.selectedDiscount.DefaultAppliedTo || 'ONE'
        });
    }

    checkManagerPin() {
        var self = this;

        if (this.state.managerPin.length < 1) {
            NotificationActions.addNotification({ type : 'alert', body : 'Manager PIN Missing' });
            return;
        }

        var formData = UserStore.getApiData();
        formData.ShipmentId = this.props.guest.ShipmentId;
        formData.PinCode = this.state.managerPin;

        AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER, formData).then(res => {
            if (res.Data[0].MgrPermission === true) {
                this.setState({ ApprovingManagerUserId: res.Data[0].UserId });
                self.addDiscount();
            } else {
                NotificationActions.addNotification({ type : 'alert', body : 'Invalid PIN' });
            }
        });
    }

    addDiscount() {
        var item                 = this.props.selectedItem;
        var guest                = this.props.guest;
        var cart                 = this.props.cart;
        var selectedDiscount     = this.props.selectedDiscount;
        var selectedLocation     = UserStore.getState().selectedLocation;

        var error = false;

        if (!this.state.selected) {
            return;
        }

        if (!item && (this.state.type_of_discount !== 'ALL' || this.state.type_of_discount !== 'TOTAL')) {
            return;
        }

        if (this.state.selected === 'amount' && this.state.amount === 0) {
            return;
        }

        if (this.state.selected === 'percent' && this.state.percent === 0) {
            return;
        }

        if (this.state.type_of_discount === 'TOTAL') {
            var formData = UserStore.getApiData();
            formData.DiscountId      = selectedDiscount.ProductId; // check to make sure how this will be sent if no item is selected
            formData.OverideDesc     = this.state.description;
            formData.Apply           = this.state.type_of_discount;
            formData.DiscountAmt     = this.state.selected === 'amount' ? this.state.amount : 0;
            formData.DiscountPercent = this.state.selected === 'percent' ? this.state.percent / 100 : 0;
            formData.ShipmentId      = guest.ShipmentId;
            formData.ProductId       = item ? item.ProductId : 0; // check to make sure how this will be sent if no item is selected
            formData.SerialNo        = item ? item.SerialNo : 0;
            formData.ApprovingManagerUserId = this.state.ApprovingManagerUserId;
            this.apply(formData, guest);
        } else if (this.state.type_of_discount === 'ALL') {
            if (!selectedLocation.DiscountOverPrice && this.state.selected === 'amount') {
                var block = false;
                for (var i=0; i<cart.length; i++) {
                    if (this.state.amount > cart[i].TotalCost / cart[i].QtyAllocated) {
                        if (!block || block > cart[i].TotalCost / cart[i].QtyAllocated)
                            block = cart[i].TotalCost / cart[i].QtyAllocated;
                    }
                }

                if (block) {
                    NotificationActions.addNotification({ type : 'alert', body : 'Discount Amount can not be greater than unit price. Maximum discount is $'+block, fullscreen: true, sticky : true });
                    return;
                }
            }

            var formData = UserStore.getApiData();
            formData.DiscountId = selectedDiscount.ProductId; // check to make sure how this will be sent if no item is selected
            formData.OverideDesc = this.state.description;
            formData.Apply = this.state.type_of_discount;
            formData.DiscountAmt = this.state.selected === 'amount' ? this.state.amount : 0;
            formData.DiscountPercent = this.state.selected === 'percent' ? this.state.percent / 100 : 0;
            formData.ShipmentId = guest.ShipmentId;
            formData.ProductId = item ? item.ProductId : 0; // check to make sure how this will be sent if no item is selected
            formData.SerialNo = item ? item.SerialNo : 0;
            formData.ApprovingManagerUserId = this.state.ApprovingManagerUserId;

            this.apply(formData, guest);

        } else {
            if (!selectedLocation.DiscountOverPrice && this.state.selected === 'amount' && this.state.amount > item.TotalCost / item.QtyAllocated) {
                NotificationActions.addNotification({ type : 'alert', body : 'Discount Amount can not be greater than unit price', fullscreen: true, sticky : true });
                return;
            }

            var formData             = UserStore.getApiData();
            formData.DiscountId      = selectedDiscount.ProductId; // check to make sure how this will be sent if no item is selected
            formData.OverideDesc     = this.state.description;
            formData.Apply           = this.state.type_of_discount;
            formData.DiscountAmt     = this.state.selected === 'amount' ? this.state.amount : 0;
            formData.DiscountPercent = this.state.selected === 'percent' ? this.state.percent / 100 : 0;
            formData.ShipmentId      = guest.ShipmentId;
            formData.ProductId       = item ? item.ProductId : 0; // check to make sure how this will be sent if no item is selected
            formData.SerialNo        = item ? item.SerialNo : 0;
            formData.ApprovingManagerUserId = this.state.ApprovingManagerUserId;
            this.apply(formData, guest);
        }
    }

    applyMultiple(formDatas, guest) {
        this.setState({ load : true });
        let promiseArr = [];
        for(let formData of formDatas) {
            formData.LoyaltyAsDiscount = UserStore.getState().selectedLocation.LoyaltyAsDiscount;
            promiseArr.push(AjaxPromises.POST(EndPoints.APPLY_DISCOUNT, formData));
        }

        RSVP.all(promiseArr).then(res => {
            for(var i = 0; i < res.length; i++) {
                if (res[i].Result) {
                    if (!res[i].Data) {
                        NotificationActions.addNotification({ type : 'alert', body : 'Discount failed', fullscreen: true, sticky : true });
                    } else {
                        NotificationActions.addNotification({ type : 'success', body : res[i].Message });
                    }
                } else {
                    NotificationActions.addNotification({ type : 'error', body : res[i].Message });
                }
            }

            PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
            PopupActions.close();
        })
    }

    apply(formData, guest) {
        this.setState({ load : true });
        formData.LoyaltyAsDiscount = UserStore.getState().selectedLocation.LoyaltyAsDiscount;
        AjaxPromises.POST(EndPoints.APPLY_DISCOUNT, formData).then(res => {
            if (res.Result) {
                if (!res.Data) {
                    NotificationActions.addNotification({ type : 'alert', body : 'Discount failed', fullscreen: true, sticky : true });
                } else {
                    NotificationActions.addNotification({ type : 'success', body : res.Message });
                    PosCartActions.loadUserCart(guest.Guest_id, guest.ShipmentId);
                    PopupActions.close();
                }
            } else {
                NotificationActions.addNotification({ type : 'error', body : res.Message });
            }
        })
    }

    onAmountChange(e) {
        this.setState({ amount : e.target.value });
    }

    onPercentChange(e) {
        var tot = e.target.value;
        if (tot > 100)
            tot = 100;
        this.setState({ percent : tot });
    }

    onDescriptionChange(e) {
        this.setState({ description : e.target.value });
    }

    onTypeChange(e) {
        this.setState({ type_of_discount : e.target.value });
    }

    selected(selected) {
        this.setState({ selected });
    }

    render() {
        var guest     = this.props.guest;
        var selectedDiscount  = this.props.selectedDiscount;
        var selected    = this.state.selected;

        var title       = !selectedDiscount ? 'Select Discount' : selectedDiscount.ProductDesc;
        var exp         = !selectedDiscount ? '' : moment(selectedDiscount.ValidateDt).format('MMM D, YYYY');
        var amount      = '';

        let disableOverride = !PermissionStore.userCan(Permissions.OverrideDiscounts);

        if (selectedDiscount) {
            amount = selectedDiscount.FlatFee !== 0 ? '$'+selectedDiscount.FlatFee.toString() : (selectedDiscount.PercentOff * 100).toString()+'%';
        }

        return (
            <div className='add-discount'>

                <div className='add-discount__header'>
                    <div className='add-discount__header--name'>
                        {title}
                    </div>
                    <div className='add-discount__header--exp'>
                        Valid From: {exp}
                    </div>
                    <div className='add-discount__header--amount'>
                        {amount}
                    </div>
                </div>

                { !selectedDiscount &&
                    <div className='add-discount__overlay'>
                        <div className='add-discount__overlay--label'>
                            Select Discount to proceed
                        </div>
                    </div>
                }

                <div className='add-discount__item add-discount__item--to'>
                    <div className='add-discount__item--title'>
                        Apply To
                    </div>

                    <select
                        value={this.state.type_of_discount}
                        onChange={this.onTypeChange} >

                        <option value='ONE'>Just One Item</option>
                        <option value='LINE'>Each Item in Row</option>
                        <option value='ALL'>Every Item in Cart</option>
                        <option value='TOTAL'>Distributed Among Every Item</option>
                    </select>
                </div>

                <div className='add-discount__item add-discount__item--amount'>
                    {selectedDiscount.DiscountType !== 'flat1' && 
                    <div className='add-discount__item--title'>
                        Discount Amount
                    </div>}
                    {selectedDiscount.DiscountType === 'flat1' &&
                    <div className='add-discount__item--title'>
                        Set Price To
                    </div>}

                    <input
                        className={''+(selected.length > 0 && selected !== 'amount' ? 'add-discount__item--disabled' : '')}
                        type='text'
                        onChange={this.onAmountChange}
                        onFocus={this.selected.bind(this, 'amount')}
                        value={this.state.amount}
                        disabled={disableOverride} />

                    <div className='add-discount__item--label'>
                        $
                    </div>
                </div>

                {selectedDiscount.DiscountType !== 'flat1' &&
                <div className='add-discount__item add-discount__item--perc'>
                    <div className='add-discount__item--title'>
                        Discount Percent Off
                    </div>

                    <input
                        className={''+(selected.length > 0 && selected !== 'percent' ? 'add-discount__item--disabled' : '')}
                        type='text'
                        onChange={this.onPercentChange}
                        onFocus={this.selected.bind(this, 'percent')}
                        value={this.state.percent}
                        disabled={disableOverride} />

                    <div className='add-discount__item--label'>
                        %
                    </div>
                </div>}

                <div className='add-discount__item add-discount__item--desc'>
                    <div className='add-discount__item--title'>
                        Discount Description
                    </div>

                    <textarea
                        onChange={this.onDescriptionChange}
                        value={this.state.description} />
                </div>

                { selectedDiscount.ManagerFlag === 'Yes' &&
                    <div className='add-discount__item add-discount__item--manager'>
                        <input
                            type='password'
                            className='add-discount__item--pwd'
                            placeholder='PIN'
                            onChange={(e) => { this.setState({ managerPin : e.target.value }); }}
                            value={this.state.managerPin} />
                    </div>
                }

                <div
                    className={'add-discount__apply '+(!selectedDiscount || !this.state.selected ? 'btn-green__disabled' : '')}
                    onClick={(selectedDiscount.ManagerFlag === 'Yes' ? this.checkManagerPin : this.addDiscount)}>

                    Apply
                </div>

            </div>
        );
    }
}

export default AddDiscount;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/discount/AddDiscount.react.jsx